import { Component, computed, effect, inject, signal, ViewEncapsulation } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { DateAdapter } from '@angular/material/core';
//import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { DateRange } from '@common/data-models/complex-types/date-range';
import { EnpsControlComponent } from '@src/suite/common/controls/enps-control/enps-control';
import { selectTranslatedKey } from '@src/suite/common/store/i18n/selectors/i18n.selectors';
import { i18nKeys } from '@src/suite/common/utils/i18n.default';
import moment, { type Moment } from 'moment-timezone';

@Component({
    selector: 'st-date-time-range',
    templateUrl: './date-time-range.html',
    styleUrls: ['./date-time-range.scss'],
    encapsulation: ViewEncapsulation.None,
    //TODO make it work with OnPush
    //changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        class: 'st-date-time-range',
    },
})
export class DateTimeRangeComponent extends EnpsControlComponent<DateRange> {
    dateAdapter = inject(DateAdapter<Moment>);
    internalValue = signal<DateRange>(new DateRange());

    range = new FormGroup({
        from: new FormControl<Moment | null>(null),
        to: new FormControl<Moment | null>(null),
    });

    constructor() {
        super();
        effect(
            () => {
                const val = this.value();
                this.internalValue.set(val || new DateRange());
                this.range.setValue({
                    from: val?.from ? moment(val.from) : null,
                    to: val?.to ? moment(val.to) : null,
                });

                if (this.dateLocale()) {
                    this.dateAdapter.setLocale(this.dateLocale());
                }
            },
            { allowSignalWrites: true }
        );
    }

    endDateLabel = computed(() => {
        return this.store.selectSignal(selectTranslatedKey(i18nKeys.PSTWebEndDateLabel))();
    });

    startDateLabel = computed(() => {
        return this.store.selectSignal(selectTranslatedKey(i18nKeys.PSTWebStartDateLabel))();
    });

    clearLabel = computed(() => {
        return this.store.selectSignal(selectTranslatedKey(i18nKeys.PSTWebDatePickerClearLabel))();
    });

    applyLabel = computed(() => {
        return this.store.selectSignal(selectTranslatedKey(i18nKeys.PSTWebApplyButtonLabel))();
    });

    closed() {
        if (this.isValueChanged()) {
            this.isValueChanged.set(false);
            this.internalValue.update(val => {
                val.from = this.range.value.from ? this.range.value.from.toDate() : null;
                val.to = this.range.value.to ? this.range.value.to.toDate() : null;
                return val;
            });
            this.changed.emit(this.internalValue());
        }
    }

    dateChange() {
        this.isValueChanged.set(true);
    }

    clearDate() {
        this.range.setValue({
            from: null,
            to: null,
        });
        this.internalValue.update(val => {
            val.from = null;
            val.to = null;
            return val;
        });
        this.changed.emit(this.internalValue());
    }
}
